export class AC101ACCalculator extends HTMLElement {
  incomeValue = 0;
  homeValueAmount = 0;
  financialAssetsValue = 0;
  otherAssetsValue = 0;
  debtsValue = 0;
  assetTestDailyFee = 0;
  incomeTestDailyFee = 0;
  incomeFreeArea = 0;
  incomeAssetThreshold = 0;

  get basicDailyFee() {
    return parseFloat(this.getAttribute('basic-daily-fee')); 
  }

  get iFASingle() {
    return parseFloat(this.getAttribute('ifa-single')); 
  }
  get iFACoupleSep() {
    return parseFloat(this.getAttribute('ifa-couple-sep')); 
  }

  get iATSingle() {
    return parseFloat(this.getAttribute('iat-single')); 
  }
  get iATCoupleCombined() {
    return parseFloat(this.getAttribute('iat-couple-combined')); 
  }

  get homeExeCap() {
    return parseFloat(this.getAttribute('home-exemption-cap')); 
  }

  get assetFreeThres() {
    return parseFloat(this.getAttribute('asset-free-threshold')); 
  }
  get assetFirstThres() {
    return parseFloat(this.getAttribute('asset-first-threshold')); 
  }
  get assetSecondThres() {
    return parseFloat(this.getAttribute('asset-second-threshold')); 
  }

  get maxAccommodationSupplementDaily() {
    return parseFloat(this.getAttribute('max-accommodation-supplement-daily')); 
  }
  get meansTestedFeeAnnualCap() {
    return parseFloat(this.getAttribute('means-tested-fee-annual-cap')); 
  }

  get hasPartner() {
    return this.querySelector('input[name="has_partner"]:checked');
  }

  get ownHome() {
    return this.querySelector('input[name="data_own_home"]:checked');
  }

  get protectedPersonInHome() {
    return this.querySelector(
      'input[name="data_protected_person_in_home"]:checked'
    );
  }

  get incomeFreeAreaValue() {
    const has_partner = this.hasPartner.getAttribute("value");

    if (has_partner == "yes") {
      return (this.incomeFreeArea = this.iFACoupleSep);
    } else {
      return (this.incomeFreeArea = this.iFASingle);
    }
  }

  get incomeAssetThresholdValue() {
    const has_partner = this.hasPartner.getAttribute("value");

    if (has_partner == "yes") {
      return (this.incomeAssetThreshold = this.iATCoupleCombined);
    } else {
      return (this.incomeAssetThreshold = this.iATSingle);
    }
  }

  get incomeLowerRateAmount() {
    if (this.financialAssetsValue > 0) {
      const lower_rate_amount =
        Math.min(this.incomeAssetThresholdValue, this.financialAssetsValue) *
        (0.25 / 100);
      return lower_rate_amount;
    } else {
      return 0;
    }
  }

  get incomeHigherRateAmount() {
    if (this.financialAssetsValue > this.incomeAssetThresholdValue) {
      const high_rate_amount =
        (this.financialAssetsValue - this.incomeAssetThresholdValue) *
        (2.25 / 100);
      return high_rate_amount;
    } else {
      return 0;
    }
  }

  get incomeAddedRate() {
    const income = isNaN(this.incomeValue) ? 0 : this.incomeValue;
    return income + this.incomeLowerRateAmount + this.incomeHigherRateAmount;
  }

  get totalAssets() {
    const financial_assets = isNaN(this.financialAssetsValue)
      ? 0
      : this.financialAssetsValue;

    const other_assets = isNaN(this.otherAssetsValue)
      ? 0
      : this.otherAssetsValue;

    const debts = isNaN(this.debtsValue) ? 0 : this.debtsValue;

    return financial_assets + Math.max(other_assets - debts, 0);
  }

  get totalIncome() {
    const has_partner = this.hasPartner.getAttribute("value");
    if (has_partner == "yes") {
      return this.incomeAddedRate / 2;
    } else {
      return this.incomeAddedRate;
    }
  }

  get totalAssetsValue() {
    const has_partner = this.hasPartner.getAttribute("value");
    if (has_partner == "yes") {
      return this.totalAssets / 2;
    } else {
      return this.totalAssets;
    }
  }

  get incomeTestDailyFeeValue() {
    if (this.totalIncome > this.incomeFreeAreaValue) {
      const total = (this.totalIncome - this.incomeFreeAreaValue) / (2 * 364);
      return this.incomeTestDailyFee + total;
    } else {
      return this.incomeTestDailyFee;
    }
  }

  get totalAssetsValueAmount() {
    const own_home = this.ownHome.getAttribute("value");
    const protected_person_in_home =
      this.protectedPersonInHome.getAttribute("value");

    const home_value = isNaN(this.homeValueAmount) ? 0 : this.homeValueAmount;

    if (own_home == "yes" && protected_person_in_home == "no") {
      const total = Math.min(home_value, this.homeExeCap);
      return this.totalAssetsValue + total;
    } else {
      return this.totalAssetsValue;
    }
  }

  get assetTestDailyFeeValue() {
    if (this.totalAssetsValue > this.assetSecondThres) {
      const total = (this.totalAssetsValue - this.assetSecondThres) * (2 / 100);

      return this.assetTestDailyFee + total;
    } else if (this.totalAssetsValue > this.assetFirstThres) {
      const total =
        (Math.min(this.totalAssetsValueAmount, this.assetSecondThres) -
          this.assetFirstThres) *
        (1 / 100);

      return this.assetTestDailyFee + total;
    } else if (this.totalAssetsValue > this.assetFreeThres) {
      const total =
        (Math.min(this.totalAssetsValue, this.assetFirstThres) -
          this.assetFreeThres) *
        (17.5 / 100);

      return this.assetTestDailyFee + total;
    } else {
      return this.assetTestDailyFee;
    }
  }

  get assetTestDailyFeeValueTotal() {
    return this.assetTestDailyFeeValue / 364;
  }

  get meansTestedDailyFee() {
    return this.incomeTestDailyFeeValue + this.assetTestDailyFeeValueTotal;
  }

  get meansTestedDailyFeeValue() {
    if (this.meansTestedDailyFee > this.maxAccommodationSupplementDaily) {
      return this.meansTestedDailyFee - this.maxAccommodationSupplementDaily;
    } else {
      return 0;
    }
  }

  get maxAccomodationDailyFee() {
    if (this.meansTestedDailyFee > this.maxAccommodationSupplementDaily) {
      return 0;
    } else {
      return this.meansTestedDailyFee;
    }
  }

  get showAccomodationFee() {
    if (this.meansTestedDailyFee > this.maxAccommodationSupplementDaily) {
      return false;
    } else {
      return true;
    }
  }

  get totalDailyFee() {
    const total = this.meansTestedDailyFeeValue + this.maxAccomodationDailyFee;
    return this.basicDailyFee + total;
  }

  get meansTestedFeeGreaterThanCap() {
    return (
      this.meansTestedDailyFeeValue > this.meansTestedFeeAnnualCap / 364
    );
  }

  connectedCallback() {
    const incomeInput = this.querySelector(".income");
    const homeValueInput = this.querySelector(".data-home-value");
    const financialAssetsInput = this.querySelector(".data-financial-assets");
    const otherAssetsInput = this.querySelector(".data-other-assets");
    const debtsInput = this.querySelector(".data-debts");

    this.querySelector(".submit").addEventListener("click", (e) => {
      const income = incomeInput as HTMLInputElement;
      const home_value = homeValueInput as HTMLInputElement;
      const financial_assets = financialAssetsInput as HTMLInputElement;
      const other_assets = otherAssetsInput as HTMLInputElement;
      const debts = debtsInput as HTMLInputElement;

      this.incomeValue = parseFloat(income.value);
      this.homeValueAmount = parseFloat(home_value.value);
      this.financialAssetsValue = parseFloat(financial_assets.value);
      this.otherAssetsValue = parseFloat(other_assets.value);
      this.debtsValue = parseFloat(debts.value);

      this.update();
    });

    console.log(this.meansTestedFeeAnnualCap)
  }

  update() {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    const total_income = isNaN(this.totalIncome) ? 0 : this.totalIncome;

    this.querySelector(
      ".ac-basic-daily-fee"
    ).textContent = `$${this.basicDailyFee}`;

    this.querySelector(".ac-means-tested-daily-fee").textContent =
      formatter.format(this.meansTestedDailyFeeValue);

    this.querySelector(".ac-accomodation-daily-fee").textContent =
      formatter.format(this.maxAccomodationDailyFee);

    this.querySelector(".ac-total-daily-fee").textContent = formatter.format(
      this.totalDailyFee
    );
    console.log("");
    console.log("Lower Income Asset Rate ", this.incomeLowerRateAmount);
    console.log("Higher Income Asset Rate ", this.incomeHigherRateAmount);
    console.log("[=============================]");
    console.log("Total Income ", formatter.format(total_income));
    console.log("Total Assets ", formatter.format(this.totalAssetsValueAmount));
    console.log("");
    console.log(
      "Income tested daily fee ",
      formatter.format(this.incomeTestDailyFeeValue)
    );
    console.log(
      "Asset tested daily fee ",
      formatter.format(this.assetTestDailyFeeValueTotal)
    );
    console.log(
      "Means tested daily fee ",
      formatter.format(this.meansTestedDailyFeeValue)
    );
    console.log(
      "Accomodation daily fee ",
      formatter.format(this.maxAccomodationDailyFee)
    );
    console.log("Total daily fee ", formatter.format(this.totalDailyFee));
    console.log("");

    const accomodationFee = this.querySelector(".accomodation-fee");
    const accomodationInformation = this.querySelector(
      ".accomodation-information"
    );
    const dataMeansTestedCapInfo = this.querySelector(
      ".data-means-tested-cap-information"
    );

    if (this.meansTestedFeeGreaterThanCap) {
      dataMeansTestedCapInfo.setAttribute("style", "display: block");
      this.querySelector(".ac-data-means-tested-annual-cap").textContent =
        formatter.format(this.meansTestedFeeAnnualCap);
    } else {
      dataMeansTestedCapInfo.setAttribute("style", "display: none");
    }

    if (this.showAccomodationFee) {
      accomodationFee.setAttribute("style", "display: block");
      accomodationInformation.setAttribute("style", "display: none");
    } else {
      accomodationFee.setAttribute("style", "display: none");
      accomodationInformation.setAttribute("style", "display: block");
    }
  }
}

customElements.define("ac101-accalculator", AC101ACCalculator);
